import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TextInput, Select, Button, Title2 } from 'advenio-components'
import { Grid as OriginalGrid, Row, Col } from 'react-flexbox-grid'
import R, { composeWith, clone } from 'ramda'
import { render } from 'react-dom'
import { Form } from 'formsy-react-2'

import CompaniesActions from '../../Data/Redux/CompaniesRedux'

const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 16px 0 16px 0;
  width: 100%;
`
export const Grid = styled(props => (
  <OriginalGrid fluid {...props}>
    {props.children}
  </OriginalGrid>
))`
  padding: 0px 6px !important;
`

const Title = styled(Title2)`
  margin-bottom: 10px;
`

class CompanyAdicionalParamters extends Component {
  constructor(props) {
    super(props)
    this.state = {
      optionsRimgentFiscal: [{ id: 0, label: 'Seleciona regimen fiscal', value: 0 }],
      value: '',

      name: '',
      rfc: '',
      address_1: '',
      address_2: '',
      address_locality: '',
      address_state: '',
      address_country: '',
      address_postcode: '',
    }
  }

  componentWillMount() {
    const { datainvoice } = this.props

    if (datainvoice.uso_cfdi_id !== null) {
      this.changeUsoCFDI({ target: { value: datainvoice.uso_cfdi_id } })
    }
  }

  handleSubmit = (data) => {
    this.props.enviainfo(this.props.company_id, data)
  }


  renderRegimenOtions = () => (
    this.props.regimenFiscal.map(relation => ({
      id: relation.sat_key,
      label: `${relation.sat_key} - ${relation.name}`,
      value: relation.sat_key,
    }))
  )

  renderUsoCFDIOtions = () => (
    this.props.uso_cfdi.filter(key => key.sat_key !== 'CP01').map(relation => ({
      id: relation.id,
      label: `${relation.sat_key} - ${relation.name}`,
      value: relation.id,
    }))
  )

  changeUsoCFDI = ({ target: { value } }) => {
    const { uso_cfdi, regimenFiscal } = this.props
    const [usoCFDI] = uso_cfdi.filter(uso => uso.id === Number(value))
    const [UsoCFDIKey] = UsoCFDIKeys.filter(key => key.id === usoCFDI.sat_key)
    const optionsRimgentFiscal = [{ id: 0, label: 'Seleciona regimen fiscal', value: 0 }].concat(clone(regimenFiscal.filter(regimen => UsoCFDIKey.regimens.includes(Number(regimen.sat_key))).map(regimenFiscal => ({
      id: regimenFiscal.sat_key,
      label: `${regimenFiscal.sat_key} - ${regimenFiscal.name}`,
      value: regimenFiscal.sat_key,
    }))))
    this.setState({ optionsRimgentFiscal })
  }

  render() {
    const { datainvoice: { name, rfc, uso_cfdi_id, regimen_fiscal, address_1, address_2, address_locality, address_state, address_country, address_postcode } } = this.props
    const { optionsRimgentFiscal } = this.state


    return (
      <div>
        <Form onSubmit={this.handleSubmit} >
          <Grid>
            <Row>
              <Col xs={12}>
                <Title>Reservaciónes B2B</Title>
              </Col>
              <Col sm={6} md={6}>
                <TextInput
                  name="limit_student_morning"
                  label="Limite Turno Mañana"
                  type="number"
                  help={'Limite de estudiantes en turno matutino'}
                />
              </Col>
              <Col sm={6} md={6}>
                <TextInput
                  name="limit_student_afternoon"
                  label="Limite Turno Tarde"
                  type="number"
                  help={'Limite de estudiantes en turno vespertino'}
                />
              </Col>
            </Row>
            <Row>
              <ButtonsRow>
                <Button success type="submit">
                  Guardar
                </Button>
              </ButtonsRow>
            </Row>
          </Grid>
        </Form>
      </div>
    )
  }
}

CompanyAdicionalParamters.defaultProps = {
  datainvoice: {
    name: '',
    rfc: '',
    address_1: '',
    address_2: '',
    address_locality: '',
    address_state: '',
    address_country: '',
    address_postcode: '',
    uso_cfdi_id: null,
    regimen_fiscal: null,

  },

}


const mapStateToProps = ({ companies, ...state }) => ({
  loading: companies.getOne.fetching,
  company: companies.getOne.result,
  restoreSuccessful: companies.restore.success,
  user: state.auth.user,
  uso_cfdi: state.uso_cfdi.get.results,
  regimenFiscal: state.regimenFiscal.get.results,
  datainvoice: companies.getOne.result.invoice_details,


})

const mapDispatchToProps = (dispatch, { match }) => ({
  activateCompany: () => dispatch(CompaniesActions.restoreRequest(match.params.id)),
  enviainfo: (company_id, data) => dispatch(CompaniesActions.updateInvoiceDetailsRequest(company_id, data)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyAdicionalParamters))



// WEBPACK FOOTER //
// ./src/Containers/CompanyAdicionalParamters/index.jsx